// extracted by mini-css-extract-plugin
export default {"heroGrid":"AiAmrSummaryView_heroGrid__6vxVa","vo2Card":"AiAmrSummaryView_vo2Card__JVTky","vo2Value":"AiAmrSummaryView_vo2Value__kqbTt"};